export const CLASS_NAMES = {
  header: 'text-20-24-em md:text-24-28-em mb-4',
  subheader: 'text-14-22 md:text-16-24 mb-4',
};

export const BUDGET_STEP = 200000;

export const MIN_BUDGET = 100000;

export const MAX_BUDGET = 2500000;

export const BUDGET_VALIDATION = {
  required: { value: true, message: 'A budget must be selected.' },
};

export const FINANCE_INTEREST_VALIDATION = {
  required: {
    value: true,
    message: 'You must select whether you are interested in finance or not',
  },
};

export const COPY = {
  header: 'Last Step! Set A Project Budget',
  subheader1:
    'Here, you can optionally select a project budget range to let us know what range of prices you feel comfortable for us to quote you within.',
  subheader2:
    "If you're not sure and want to see what monthly repayments could look like with Ideal4Finance finance, try using our handy calculator below. Otherwise, we can discuss this with you when we call",
};
